import moment from "moment";

/**
 * Generate 7 consecutive UTC dates starting from a given date or today.
 *
 * @param startDate - Optional start date in YYYY-MM-DD format. Defaults to start of current week.
 * @returns Array of 7 date strings in YYYY-MM-DD format
 */
export function generateWeekDates(startDate?: string): string[] {
  const start = startDate ? moment.utc(startDate) : moment.utc().startOf("week");
  const dates: string[] = [];
  for (let i = 0; i < 7; i++) {
    dates.push(start.clone().add(i, "days").format("YYYY-MM-DD"));
  }
  return dates;
}
